import { getParticipationList, addParticipation, updateParticipation, deleteParticipation } from "@/services/participation.service";
import { setPaginationDetails, formatDate } from "@/utils/utils";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  //Sertifika Listesi
  async loadPariticipationList(vuexContext, co) {
    return await getParticipationList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((student) => {
        student.certificateStudentFullname = student.studentName == student.studentSurname ? student.studentName : `${student.studentName} ${student.studentSurname}`;
        student.level = student.classStatusMulti?.classStatus?.levels?.description;
        student.totalTime = student.classStatusMulti?.classStatus?.endTime;
        student.startEndDate = formatDate(student.classStatusMulti?.startDate) + " - " + formatDate(student.classStatusMulti?.endDate);
      });

      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async postParticipation(vuexContext, certificate) {
    return await addParticipation(certificate).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async updatePariticipation(vuexContext, certificate) {
    return await updateParticipation(certificate).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async deletePariticipation(vuexContext, certificate) {
    return await deleteParticipation(certificate).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
